// extracted by mini-css-extract-plugin
export default {"name":"ContactForm_name__ce0ky","email":"ContactForm_email__lYmZu","subject":"ContactForm_subject__O59mf","message":"ContactForm_message__UV4b-"};